import EditScreenInfo from "../components/EditScreenInfo";
import { Text, View } from "../components/Themed";
import { RootTabScreenProps } from "../types";

import React, { useState, useEffect } from "react";
import { StyleSheet, Dimensions, useWindowDimensions, ScrollView } from "react-native";
import { Amplify, Auth, Hub, API, graphqlOperation } from "aws-amplify";
import { GraphQLQuery } from "@aws-amplify/api";
import { createSettingsAPI, updateSettingsAPI, deleteSettingsAPI } from "../graphql/mutations";
import { getSettingsAPI, listSettingsAPIS, syncSettingsAPIS } from "../graphql/queries";
import { ListSettingsAPISQueryVariables, ListSettingsAPISQuery, CreateSettingsAPIInput, CreateSettingsAPIMutation, UpdateSettingsAPIMutation, DeleteSettingsAPIMutation } from '../graphql/settingsAPI';

import awsmobile from "../aws-exports";
import { UserAgent } from "amazon-cognito-identity-js";

const windowDimensions = Dimensions.get("window");
const screenDimensions = Dimensions.get("screen");

// async function getUserInfo() {
//   try {
//     const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
//     console.log("attributes:", user.attributes);
//     console.log("TYPE:", typeof user.attributes);
//     console.log("STUFF1:", Object.keys(user));
//     console.log("STUFF2:", Object.values(user));
//     const [stuff, setStuff] = useState({ id: "name" });
//     return user;  
//   } catch (error) {
//     console.log("ERROR: getUserInfo - ", error);
//   }
// }


// async function setSettingsAPI() {
//   try {
//     const setting: CreateSettingsAPIInput = { name: "Marc Davidson", description: "number one son" };
//     const createSetting = await API.graphql<GraphQLQuery<CreateSettingsAPIMutation>>(graphqlOperation(createSettingsAPI, {input: setting}));
//     // console.log(setting);
//     console.log(createSetting);
//     return createSetting;      
//   } catch (error) {
//       console.log("OLD ERROR: setSettingsAPI - ", error);
//   }
// }

// async function listSettingsAPI() {
//   try {
//     let settingsList = await API.graphql<GraphQLQuery<ListSettingsAPISQuery>>(graphqlOperation(listSettingsAPIS));
//     return (settingsList);  
//   } catch (error) {
//       console.log("ERROR: listSettingsAPI - ", error);
//   }
// }


// TODO: Make sure full json object gets returned from the list settings function to the settigns screen function and print
// TODO: ListSettings functions executes and returns data but the settingsList object doesn't show the values in the GUI
export default function SettingsScreen({
  navigation,
}: RootTabScreenProps<"Settings">) {
  const { height, width, scale, fontScale } = useWindowDimensions();
  const [today, setToday] = useState(Date);



  // setSettingsAPI();
  // let [stuff, setStuff] = useState([]);
  try {
      // getUserInfo();

    // let settingsList = useState([]);
    let settingsList = [];
  //   listSettingsAPI().then(settingsList => {
  //     // setStuff(settingsList.data.listSettingsAPIS.items);
  //     // console.log("RESULT:", settingsList);
      
  //  });

    return (
      <View style={styles.container}>
        <Text style={styles.header}>Window Dimension Data</Text>
        <Text>Height: {height}</Text>
        <Text>Width: {width}</Text>
        <Text>Font scale: {fontScale}</Text>
        <Text>Pixel ratio: {scale}</Text>
        {/* <Text>{today}</Text> */}
        {/* <Text>STUFF: {JSON.stringify(stuff, null, 2)}</Text> */}
        {/* <ScrollView>
        <View>
          {stuff.map((s) => {
            return (
              <View>
                <Text key={s.id}> {s.id} - {s.name}</Text>
              </View>
            );
          })}
        </View>
        </ScrollView> */}
      </View>
    );    
  } catch (error) {
    console.log("ERROR: SettingsScreen - ", error);
  }
  // const settingsList = listSettingsAPI().then(settingsList => console.log(settingsList));
  // console.log("SETTINGS LIST: ", JSON.stringify(settingsList, null, 2));
  // console.log("STUFF:", settingsList );

}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  header: {
    fontSize: 20,
    marginBottom: 12,
  },
});
